import { render, staticRenderFns } from "./Verifikasi.vue?vue&type=template&id=d90e0292&"
import script from "./Verifikasi.vue?vue&type=script&lang=js&"
export * from "./Verifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports